export default __webpack_public_path__ + "static/media/sample.da550152.svg";